import React from 'react';
import { cn } from '../../utils/styles';

interface FadeInProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right';
}

const FadeIn: React.FC<FadeInProps> = ({ 
  children, 
  className,
  delay = 0,
  direction = 'up'
}) => {
  const getDirectionClasses = () => {
    switch (direction) {
      case 'up': return 'translate-y-8';
      case 'down': return '-translate-y-8';
      case 'left': return 'translate-x-8';
      case 'right': return '-translate-x-8';
      default: return 'translate-y-8';
    }
  };

  return (
    <div
      className={cn(
        'opacity-0 animate-fade-in',
        getDirectionClasses(),
        className
      )}
      style={{ 
        animationDelay: `${delay}s`,
        animationFillMode: 'forwards'
      }}
    >
      {children}
    </div>
  );
};

export default FadeIn;